import builder from '../builder';
import Add from '../../streamline-icons/bold/add.svg';

export default builder('IconAddBold', Add);
